import React from 'react';
import './index.css';
import clsx from 'classnames';
import QueueAnim from 'rc-queue-anim';
import { useHistory } from 'react-router-dom';

const NewsItem = (props) => {
  const { v, index } = props;
  const history = useHistory();
  const { title, cover, add_time, id } = v;

  const onClick = () => {
    history.push(`/news/${id}`);
  };

  const imgUrl = 'http://offical-php.zjzyfwq.com/uploads/' + cover[0]?.filename;
  return (
    <QueueAnim
      className={clsx('news-content-list-item')}
      key={index}
      type={['right', 'left']}
      onClick={onClick}
    >
      <div className={clsx('news-content-list-item-img')} key='img'>
        <img src={imgUrl} alt='' width={'100%'} height={'100%'} />
      </div>
      <div className={clsx('news-content-list-item-text')} key='text'>
        <div className={clsx('news-content-list-item-text-title')}>{title}</div>
        <div className={clsx('news-content-list-item-text-time')}>
          {add_time?.slice(0, 10)}
        </div>
        <div className={clsx('news-content-list-item-text-desc')}>···</div>
      </div>
    </QueueAnim>
  );
};

export default NewsItem;
